import { AvailabilityType, ICharacteristic, ILinkedError, IWorkOrder, IWorkOrderType } from "./resource";
import { IIncidentType } from "./incidentTypes";
import { RRule } from "rrule";
import { TravelLabelAlignment, TravelSegmentKind } from "./travel";

interface IEventBase {
    resourceId: string;
    title: string;
    start: Date;
    end: Date;
    id: string;
    displayColor: string | undefined;
    shiftLength: number;
    isCancellationRequestPendingOriginal?: boolean;
    display?: string | undefined;
}

interface IEvent extends IEventBase {
    exceededMaxWorkingHours?: boolean;
    description: string
    status: ESystemStatus
    calendarStatus: ECalendarStatus
    BookingId: string
    bookableResourceStatus: EBookingStatus
    preferredResourceId: string
    preferredResourceName: string
    isJobBidding: boolean
    originalResourceID: string
    jobType: string
    serviceAccount: IServiceAccount
    serviceContact?: IServiceContact
    incidentType: IIncidentType
    bidders: IBookableResourceBooking[];
    changeStatus: ChangeStatus;
    errors?: string[]
    linkedErrors?: ILinkedError[]
    displayCost: number | null; //if reassigned, this will be set to null. if assigned back to original, value will set from actualCost
    actualCost: number;
    hourlyRate?: number | null;
    estimatedTravelDuration?: number | null;
    products?: any[];
    services?: any[];
    isOverTime: boolean;
    missingSkills: boolean;
    unavailable: boolean;
    loadingLock?: boolean;
    loading: boolean;
    validating: boolean;
    resourcePublishedAs: string;
    detailsModified?: boolean;
    editable: boolean | undefined;
    resourceEditable: boolean | undefined;
    cancellationRequestComments?: string;
    workOrderType: IWorkOrderType;
    allDay?: boolean;
    availabilityType?: AvailabilityType;
    rrule:any;
    duration:string;
    isClientLateCancel?: boolean
    smartMatched?: boolean;
    siteLocationDetails?: {
        id?: string;
        name?: string;
        address?: string;
        latitude?: number | null;
        longitude?: number | null;
    };
}

interface IOtherSiteEvent extends IEventBase {
    editable: false;
    resourceEditable: false;
    startEditable: false;
    otherSite: true;
    jobType: string;
    customerFullName?: string;
    siteLocation: string;
    workOrderType: IWorkOrderType;
}

interface ITravelEvent extends IEventBase {
    display: 'travel';
    editable: false;
    resourceEditable: false;
    description: string;
    travelKind: TravelSegmentKind;
    labelAlign: TravelLabelAlignment;
    durationSeconds: number;
    distanceMeters: number;
    overflowMinutes: number;
    anchorShiftIds: string[];
    travelLabel: string;
    travelTooltip: string;
    siteLocationDetails?: {
        id?: string;
        name?: string;
        address?: string;
        latitude?: number | null;
        longitude?: number | null;
    };
}


interface IBookableResourceBooking {
    bookingStatus: string;
    id: string;
    bookableResourceId: string;
    bookableResource: any;
    invitationSeenAt?: string | null;
    invitationOpenedAt?: string | null;
    isSeen?: boolean;
    isOpened?: boolean;
    errors: ILinkedError[];
    isOverTime: boolean;
    missingSkills: boolean;
    unavailable: boolean;
    exceededMaxWorkingHours: boolean;
}


enum ChangeStatus {
    UnChanged = 0,
    New = 1,
    Modified = 2,
    Deleted = 3
}

interface IServiceAccount {
    name: string
    accountId: string
    accountNumber: string
    address1_composite?: string
}

interface IServiceContact {
    fullName?: string
    contactId?: string
}

enum EBookingStatus {
    "Scheduled" = 'f16d80d1-fd07-4237-8b69-187a11eb75f9', //Green
    "ValidationError" = '432cdef3-2ace-ea11-a812-000d3ad0ea2d', //Yellow
    "Cancelled" = '0adbf4e6-86cc-4db0-9dbb-51b7d1ed4020' // Red
}


enum ECalendarStatus {
    scheduled,
    assigned,
    issue,
    error
}

enum EWorkWorderType {
    Active,
    OnCall,
    Sleepover,
    AvantCareServiceTypeDonotremove
}


enum ESystemStatus {
    'Unscheduled' = 690970000,
    'Scheduled' = 690970001,
    'In Progress' = 690970002,
    'Completed' = 690970003,
    'Posted' = 690970004,
    'Canceled' = 690970005,
}

export { EBookingStatus, ESystemStatus, ChangeStatus, ECalendarStatus, EWorkWorderType };
export type { IEvent, IOtherSiteEvent, ITravelEvent, IBookableResourceBooking, IEventBase };
